module.exports = __webpack_public_path__ + "img/pink-words-NEW.9750062d.png";